"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var constants_1 = require("containers/TableMaker/constants");
var AddInCCWrapper_1 = __importDefault(require("./AddInCCWrapper"));
var EmailHeadersCell_1 = __importDefault(require("./EmailHeadersCell"));
var EmailHeadersRow_1 = __importDefault(require("./EmailHeadersRow"));
var XL = constants_1.CellSize.XL, LG = constants_1.CellSize.LG, XS = constants_1.CellSize.XS;
var AddInCCRow = function (_a) {
    var email = _a.email, name = _a.name;
    return ((0, jsx_runtime_1.jsxs)(EmailHeadersRow_1.default, { children: [(0, jsx_runtime_1.jsx)(EmailHeadersCell_1.default, __assign({ width: XL + XS + XS }, { children: (0, jsx_runtime_1.jsx)(AddInCCWrapper_1.default, { children: email }) })), (0, jsx_runtime_1.jsxs)(EmailHeadersCell_1.default, __assign({ width: LG + 16 }, { children: [(0, jsx_runtime_1.jsx)(AddInCCWrapper_1.default, { children: name }), (0, jsx_runtime_1.jsx)("div", { style: { width: 8 } })] }))] }));
};
exports.default = AddInCCRow;
